import StreamSearch from './StreamSearch';

export default StreamSearch;
